import axios from 'axios';

// Base URL for API calls
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Submit a contact form
 * @param {Object} formData - The contact form data
 * @param {string} formData.name - The name of the person submitting the form
 * @param {string} formData.email - The email of the person submitting the form
 * @param {string} formData.subject - The subject of the message
 * @param {string} formData.message - The message content
 * @returns {Promise} - A promise that resolves with the API response
 */
export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/forms/contact/`, formData);
    return { success: true, data: response.data };
  } catch (error) {
    // Handle rate limiting error
    if (error.response && error.response.status === 429) {
      return { 
        success: false, 
        error: 'You have submitted too many requests. Please try again in a few minutes.' 
      };
    }
    
    // Handle other errors
    return { 
      success: false, 
      error: error.response?.data?.error || 'An error occurred while submitting the form. Please try again.' 
    };
  }
};

/**
 * Subscribe to the newsletter
 * @param {string} email - The email address to subscribe
 * @returns {Promise} - A promise that resolves with the API response
 */
export const subscribeNewsletter = async (email) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/forms/subscribe/`, { email });
    return { success: true, data: response.data };
  } catch (error) {
    // Handle rate limiting error
    if (error.response && error.response.status === 429) {
      return { 
        success: false, 
        error: 'You have subscribed too many times. Please try again in a few minutes.' 
      };
    }
    
    // Handle duplicate email error
    if (error.response && error.response.status === 400 && 
        error.response.data && error.response.data.email && 
        error.response.data.email[0] && 
        error.response.data.email[0].includes('already exists')) {
      return { 
        success: false, 
        error: 'This email is already subscribed to our newsletter.' 
      };
    }
    
    // Handle other errors
    return { 
      success: false, 
      error: error.response?.data?.error || 'An error occurred while subscribing. Please try again.' 
    };
  }
};
